module.exports = __webpack_public_path__ + "img/granada_background_hero.30bbfcdb.png";